import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import GeneralForm from '../../components/generalForm';
import { connect } from 'react-redux';
import CustomSelect from '../../components/customFields/customSelect';
import GooglePlacesField from '../../components/customFields/googlePlacesField';
import Helmet from 'react-helmet';

const StartDepotForm = ({ match, action, intl, history }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDepot, setStartDepot] = useState({});
  const [serviceAreas, setServiceAreas] = useState([]);

  useEffect(() => {
    if (action === 'edit') {
      setError(null);
      setLoading(true);
      apiCalls
        .getStartDepots({
          startDepotId: match.params.startDepotId,
        })
        .then((result) => {
          setStartDepot(transformStartDepotForForm(result.data.startDepots[0]));
          setLoading(false);
          getServiceAreas();
        })
        .catch((errors) => {
          setError(utils.getErrorMessageFromResponse(errors));
          setLoading(false);
        });
    } else {
      getServiceAreas();
    }
  }, [match.params.startDepotId]);

  function getServiceAreas() {
    apiCalls
      .getServiceAreas()
      .then((result) => {
        setServiceAreas(result.data.serviceAreas);
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }

  const serviceAreaOptions = serviceAreas.map((serviceArea) => {
    return {
      value: serviceArea.id,
      label: `#${serviceArea.id} ${serviceArea.name}`,
    };
  });

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      name: {
        type: 'string',
        title: intl.formatMessage({ id: 'start.depot.form.field.name.label' }),
      },
      serviceAreaId: {
        type: 'string',
        title: intl.formatMessage({ id: 'start.depot.form.field.service.area.id.label' }),
        options: serviceAreaOptions,
      },
      address: {
        type: 'object',
        required: [],
        properties: {
          unit: {
            type: 'string',
            default: '',
          },
          street: {
            type: 'string',
            default: '',
          },
          city: {
            type: 'string',
            default: '',
          },
          country: {
            type: 'string',
            default: '',
          },
          postCode: {
            type: 'string',
            default: '',
          },
          coordinates: {
            type: 'object',
            required: [],
            properties: {
              lat: {
                type: 'string',
              },
              lon: {
                type: 'string',
              },
            },
          },
        },
      },
    },
  };

  const uiSchema = {
    serviceAreaId: {
      'ui:field': 'customSelect',
    },
    address: {
      'ui:field': 'googlePlacesField',
    },
  };

  function onFormSubmit() {
    setLoading(true);

    if (action === 'edit') {
      return apiCalls
        .editStartDepot({ startDepot })
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: '/admin/startDepots',
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    } else {
      return apiCalls
        .createStartDepot({ startDepot })
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: '/admin/startDepots',
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    }
  }

  const buttonCopy = action === 'edit' ? 'start.depot.edit.form.submit' : 'start.depot.create.form.submit';

  const formFields = {
    googlePlacesField: GooglePlacesField,
    customSelect: CustomSelect,
  };

  const header =
    action === 'edit' && !loading
      ? intl.formatMessage({ id: 'start.depot.edit.header' }, { startDepot: startDepot.id })
      : intl.formatMessage({ id: 'start.depot.create.header' });

  return (
    <div className="row">
      <Helmet>
        <title>{header}</title>
      </Helmet>
      <div className="col-12 col-lg-10 offset-lg-1 admin__form">
        <GeneralForm
          title={header}
          onChange={(event) => setStartDepot(event.formData)}
          onSubmit={onFormSubmit}
          formSchema={formSchema}
          formUiSchema={uiSchema}
          formFields={formFields}
          formData={startDepot}
          buttonCopy={buttonCopy}
          errorMessage={error}
          loading={loading}
          hideImageUpload={true}
        />
      </div>
    </div>
  );
};

function transformStartDepotForForm(startDepot) {
  return {
    ...startDepot,
  };
}

StartDepotForm.propTypes = {
  currentUser: PropTypes.object,
  action: PropTypes.string.isRequired,
};

StartDepotForm.defaultProps = {
  action: 'create',
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(StartDepotForm));
